import { jsx as o } from "react/jsx-runtime";
const h = (t) => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 24 24", ...t, children: /* @__PURE__ */ o(
  "path",
  {
    fill: "#8E8EA9",
    d: "m17.654 1.7-2.782 2.533a9.138 9.138 0 0 1 3.49 1.973c3.512 3.2 3.512 8.388 0 11.588-2.592 2.36-6.598 3.862-12.016 4.506l2.782-2.533a9.138 9.138 0 0 1-3.49-1.973c-3.512-3.2-3.533-8.369 0-11.588C8.23 3.846 12.237 2.344 17.655 1.7h-.001ZM12 8c-2.485 0-4.5 1.79-4.5 4s2.015 4 4.5 4 4.5-1.79 4.5-4-2.015-4-4.5-4Z"
  }
) }), l = h;
export {
  l as default
};
